






import { Vue, Component, Prop } from "vue-property-decorator";
import BigNumber from "bignumber.js";

@Component
export default class USD extends Vue {
  @Prop({ default: "0.00" }) value!: string | number;
  public get price(): string {
    return new BigNumber(Number(this.value)).toFixed(2);
  }

  public get renderPrice(): string {
    return this.price.replace(/-/g, "");
  }

  public get priceMoreThanZero(): boolean {
    return Number(this.price) >= 0;
  }
}
